import i18next from "i18next";
import { Button } from "@material-ui/core";
import CheckBoxIcon from "@material-ui/icons/CheckBox";


export default function MeetingRooms({ rooms, selectedRoom, setSelectedRoom })
{
    const roomBlock = roomId => {
        const isSelected = (selectedRoom !== null && selectedRoom == roomId);
        return (
            <Button 
                key={roomId} variant="outlined" size="large" disabled={isSelected} startIcon={isSelected ? <CheckBoxIcon /> : null}
                onClick={() => setSelectedRoom(roomId)}
            >
                {rooms[roomId]}
            </Button>
        );
    }

    return (<>
        <div className="meeting-room">{i18next.t("meeting_rooms")}</div>
        {Object.keys(rooms).length > 0 && Object.keys(rooms).map(roomBlock)}
    </>);
}
